export default __webpack_public_path__ + "static/media/message.650350e3.svg";